import Logger from "../../../../clients/logger";

import { WindowPrimitives as FinsembleWindowPrimitivesEntry } from "./windowPrimitivesEntryPoints";
import { WindowCreateEntry as FinsembleWindowCreateEntry } from "./windowCreateEntryPoints";
import { LauncherEntry as FinsembleLauncherEntry } from "./launcherEntryPoints";
import { Launcher } from "../Launcher/launcher";
import DockingMain from "../Docking/dockingMain";

export class ServiceEntryPoints {
	finsembleLauncherEntry: FinsembleLauncherEntry;

	finsembleWindowPrimitivesEntry: FinsembleWindowPrimitivesEntry;

	finsembleWindowCreateEntry: FinsembleWindowCreateEntry;

	constructor(dockingMain: DockingMain, launcher: Launcher) {
		this.finsembleLauncherEntry = new FinsembleLauncherEntry(launcher);
		this.finsembleWindowPrimitivesEntry = new FinsembleWindowPrimitivesEntry(dockingMain, launcher);
		this.finsembleWindowCreateEntry = new FinsembleWindowCreateEntry(launcher);
		this.bindFunctions();
	}

	bindFunctions() {
		this.initialize = this.initialize.bind(this);
	}

	async initialize() {
		Logger.system.debug("ServiceEntryPoints.initialize start");
		this.finsembleWindowPrimitivesEntry.initialize();
		Logger.system.debug("ServiceEntryPoints.initialize done");
		this.finsembleLauncherEntry.setReady();
		this.finsembleWindowPrimitivesEntry.setReady();
		this.finsembleWindowCreateEntry.setReady();
	}
}
